export default "__VITE_ASSET__Djt_XfhR__"